/**
 * O mapa desenha em escala fixa. Ctrl+roda, Ctrl+mais/menos/0 e o pinça
 * do trackpad são o zoom do navegador — eles esticam a página inteira.
 */

const CODIGOS = new Set([
  'Equal', 'Minus', 'NumpadAdd', 'NumpadSubtract', 'Digit0', 'Numpad0'
]);

function atalhoDeZoom(e: KeyboardEvent): boolean {
  if (!(e.ctrlKey || e.metaKey) || e.altKey) return false;
  return CODIGOS.has(e.code);
}

function travarRoda(e: WheelEvent) {
  if (e.ctrlKey || e.metaKey) e.preventDefault();
}

function travarTecla(e: KeyboardEvent) {
  if (atalhoDeZoom(e)) e.preventDefault();
}

function travarGesto(e: Event) {
  e.preventDefault();
}

export function travarZoomNavegador() {
  window.addEventListener('wheel', travarRoda, { passive: false, capture: true });
  window.addEventListener('keydown', travarTecla, { capture: true });
  window.addEventListener('gesturestart', travarGesto, { passive: false });
  window.addEventListener('gesturechange', travarGesto, { passive: false });
}
